"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sup = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = require("../Text");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Sup = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "Sup",
  componentId: "sc-1g83qfs-0"
})(["display:inline;vertical-align:super;font-size:75% !important;line-height:0 !important;font-weight:inherit !important;"]);
exports.Sup = Sup;